<div class="mb-3">
  <div class="fw-bold">No te preocupes, a todos nos pasa.</div>
  <div class="text-secondary">Escribe tu dirección de correo electrónico aquí abajo y te mandaremos un enlace directo para restablecer tu contraseña de forma segura. ¡Volverás a entrar en un santiamén!</div>
</div>
<form [formGroup]="form">
  <div class="form-group mb-3 position-relative">
    <i class="fa-solid fa-envelope icon-input"></i>
    <input type="email" class="form-control ps-5" placeholder="Correo electrónico" (keyup)="error=''"
      [disabled]="busy"
      formControlName="email" autocomplete="email" required maxlength="320">
  </div>
  <div class="mb-3 alert alert-success" role="alert" *ngIf="aviso!=''">
    <i class="fa-solid fa-triangle-exclamation pe-2 fs-4"></i><span [innerHTML]="aviso"></span>
  </div>
  <div class="mb-3 alert alert-danger" role="alert" *ngIf="error!=''">
    <i class="fa-solid fa-triangle-exclamation pe-2 fs-4"></i><span [innerHTML]="error"></span>
  </div>
  <div class="row mt-3" *ngIf="aviso==''">
    <div class="col d-grid gap-2">
      <button class="btn btn-secondary" type="button" [disabled]="busy" (click)="Volver()">
        Cancelar
      </button>
    </div>
    <div class="col d-grid gap-2">
      <button class="btn btn-primary" type="button" [disabled]="form.invalid || busy" (click)="recordarPassword()">
        <div class="spinner-border spinner-border-sm" role="status"
            *ngIf="busy">
          <span class="visually-hidden">Loading...</span>
        </div>
        Recordar
      </button>
    </div>
  </div>
  <div class="row mt-3" *ngIf="aviso!=''">
    <div class="col d-grid gap-2">
      <button class="btn btn-secondary" type="button" [disabled]="busy" (click)="Volver()">
        Volver
      </button>
    </div>
  </div>
</form>
